import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  row: {
    display: 'flex',
  },
})

const Row = ({ left, right, classes }) => {
  return (
    <article className={classes.row}>
      <section>{left}</section>
      <section>{right}</section>
    </article>
  )
}

export default withStyles(styles)(Row)
